module.exports = __webpack_public_path__ + "static/media/vidsecure.2cc0fc4b.png";